import api from "../../utils/Api";

const BackendAdminApiBaseUrl = process.env.REACT_APP_ADMIN_URL;

const ptmAccountApi = {
  async listAccount(params) {
    const response = await api.get(
      BackendAdminApiBaseUrl + "/ptm/ptmsAccounts",
      { params }
    );
    return response;
  },

  async getSingleAccount(id) {
    const response = await api.get(
      BackendAdminApiBaseUrl + `/ptm/ptmsAccounts/${id}`
    );
    return response;
  },
  async getSignedUrl(payload) {
    const response = await api.post(
      BackendAdminApiBaseUrl + "/admin-upload/signed-url",
      payload
    );
    return response;
  },
  async createAccount(payload) {
    const response = await api.post(
      BackendAdminApiBaseUrl + "/ptm/ptmsAccounts",
      payload
    );
    return response;
  },

  async updateAccount(id, payload) {
    const response = await api.patch(
      BackendAdminApiBaseUrl + `/ptm/ptmsAccounts/${id}`,
      payload
    );
    return response;
  },
  async checkPtmProvisioning() {
    const response = await api.get(BackendAdminApiBaseUrl + "/ptm/checkStatus");
    return response;
  },
  async changePTMStatus(status, accountId) {
    try {
      const params = { status, accountId };
      const response = await api.get(
        BackendAdminApiBaseUrl + "/ptm/ptmsAccounts/status",
        { params }
      );
      return response;
    } catch (error) {
      console.error(error)
      const apiMessage =
        error?.response?.data?.message || "Failed to change PTM status";
      throw new Error(apiMessage);
    }
  },
  async searchDomains(subDomain) {
    const response = await api.get(
      BackendAdminApiBaseUrl + "/ptm/searchDomains",
      { params: { subDomain } }
    );
    return response;
  }
};

export default ptmAccountApi;
